export const CHILD_EMIT = 'child-output';
export const CHILD_EMIT_SECONDARY = 'secondary-child-output';

export const CHILD_EMIT_403 = 'child-emit-403';